import { render, staticRenderFns } from "./PeriodicTrialBalance.vue?vue&type=template&id=3c95a972&"
import script from "./PeriodicTrialBalance.vue?vue&type=script&lang=js&"
export * from "./PeriodicTrialBalance.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicTrialBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports